<div class="form-group-planetun" [formGroup]="formGroup">
    <label [for]="id">{{title}}</label>
    <select id="{{ id }}" *ngIf="readonly" class="disable-color" disabled [name]="name" [formControlName]="controlName">
        <option *ngFor="let item of values" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <select id="{{ id }}" *ngIf="!readonly" [name]="name" [class]="classInfo" [formControlName]="controlName">
        <option *ngFor="let item of values" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <div class="erro" *ngIf="validate.hasErrorValidate(formControl, 'required') && !errorMessage">Campo Obrigatório</div>
    <div class="erro" *ngIf="errorMessage && formControl.dirty && formControl.invalid">{{ errorMessage }}</div>
</div>